import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { fetchFiltersForMachine } from "api/myMachines";
import { useCart } from "context/CartContext";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NumberInput from "../NumberInput";
function FilterInMachinesGroup() {
  const { machineId } = useParams();

  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState({});

  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [hourFilters, setHourFilters] = useState({
    reset: false,
    250: false,
    500: false,
    1000: false,
    all: false,
  });

  const storageUrl = process.env.REACT_APP_STORAGE_URL;

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const { data } = await fetchFiltersForMachine(machineId);
        setFilters(data || []);
      } catch (err) {
        setError(err.message || "Failed to load filters.");
      } finally {
        setLoading(false);
      }
    };
    if (machineId) fetchFilters();
  }, [machineId]);

  useEffect(() => {
    const initialQuantities = {};
    filters.forEach((filter) => {
      initialQuantities[filter.id] = filter.amount || 1;
    });
    setQuantity(initialQuantities);
  }, [filters]);

  const handleQuantityChange = (id, value) => {
    setQuantity((prev) => ({
      ...prev,
      [id]: Math.max(1, Math.min(99, parseInt(value) || 0)),
    }));
  };

  const handleAddToCart = () => {
    filters.forEach((filter) => {
      if (selectedFilters[filter.id]) {
        const numberOfItems = quantity[filter.id] || 1;
        addToCart(filter, numberOfItems);
      }
    });
  };

  const handleCheckboxChange = (id) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleHourFilterChange = (hour) => {
    setHourFilters((prev) => {
      let newFilters = { ...prev };

      if (hour === "all") {
        newFilters = {
          reset: false,
          250: true,
          500: true,
          1000: true,
          all: true,
        };
      } else if (hour === "reset") {
        newFilters = {
          reset: true,
          250: false,
          500: false,
          1000: false,
          all: false,
        };
      } else {
        newFilters[hour] = !prev[hour];
        if (newFilters[hour]) {
          if (hour === 1000) {
            newFilters[500] = true;
            newFilters[250] = true;
          } else if (hour === 500) {
            newFilters[250] = true;
          }
        }

        newFilters.all = newFilters[250] && newFilters[500] && newFilters[1000];
        newFilters.reset =
          !newFilters[250] && !newFilters[500] && !newFilters[1000];
      }

      const newSelectedFilters = {};
      filters.forEach((filter) => {
        if (
          (newFilters[250] && filter.filter_hour === 250) ||
          (newFilters[500] && filter.filter_hour === 500) ||
          (newFilters[1000] && filter.filter_hour === 1000) ||
          newFilters.all
        ) {
          newSelectedFilters[filter.id] = true;
        } else {
          newSelectedFilters[filter.id] = false;
        }
      });
      setSelectedFilters(newSelectedFilters);

      return newFilters;
    });
  };

  const isAnySelected = useMemo(
    () => Object.values(selectedFilters).some(Boolean),
    [selectedFilters]
  );

  if (loading)
    return (
      <Stack
        spacing={2}
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress sx={{ color: "#424242" }} />
      </Stack>
    );
  if (error)
    return (
      <Stack
        spacing={2}
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography color="error">{error}</Typography>
        <Box
          sx={{
            width: "100%",
            maxWidth: "150px",
            height: "40px",
            backgroundColor: "#424242",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:hover": {
              backgroundColor: "#686868",
            },
            flexShrink: 0,
            margin: "10px",
          }}
        >
          <Button
            sx={{
              color: "#ffffff",
              textTransform: "none",
            }}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Box>
      </Stack>
    );
  if (!filters.length)
    return (
      <>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-start",
            alignItems: "center",
          }}
          m={3}
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon />
          <Typography color="text.primary" marginX={5}>
            <strong>Maskiner</strong>
          </Typography>
        </Stack>
        <Stack
          spacing={2}
          sx={{
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>Ingen filtre fundet.</Typography>
        </Stack>
      </>
    );

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "flex-start",
          alignItems: "center",
        }}
        m={3}
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon />
        <Typography color="text.primary" marginX={5}>
          <strong>Maskiner</strong>
        </Typography>
      </Stack>
      <Stack direction="column" spacing={2} marginX={2} marginY={4}>
        {filters.map((item) => (
          <Card
            key={item.id}
            sx={{
              display: "flex",
              flexDirection: "row",
              height: "100%",

              overflow: "hidden",
              boxSizing: "border-box",
            }}
            elevation={3}
          >
            <CardContent
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                padding: "16px",
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={"10px"}
              >
                <Box
                  sx={{
                    maxHeight: 50,
                    maxWidth: 50,
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={
                      item.s_icon
                        ? `https://minio.jlfiltersystem.dk/uploads/${item.s_icon}`
                        : "/images/filter_1836109.png"
                    }
                    alt={item.s_name}
                    style={
                      item.s_icon
                        ? { width: "100%", height: "auto" }
                        : { width: "80%", height: "auto" }
                    }
                  />
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {item.amount}/{item.jl_number}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Timer: {item.filter_hour}
                  </Typography>

                  {item.s_name !== null && (
                    <Typography variant="body1" color="text.secondary">
                      Type: {item.s_name}
                    </Typography>
                  )}
                </Box>
              </Box>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                  {item.price === null || !item.price ? (
                    <Typography variant="body2" color={"#FF9100"}>
                      <strong>Ring for pris</strong>
                    </Typography>
                  ) : item.price?.Unit_Price ===
                    item.prices?.Unit_Price_Discount ? (
                    <Typography variant="body1" color={"#00712D"}>
                      <strong>{item.price?.Unit_Price.toFixed(2)} Dkk</strong>
                    </Typography>
                  ) : (
                    <Typography variant="body1" color={"#00712D"}>
                      <strong>
                        {item.price?.Unit_Price_Discount.toFixed(2)} Dkk
                      </strong>
                    </Typography>
                  )}
                </Box>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <NumberInput
                    value={quantity[item.id] || item.amount || 1}
                    onChange={(e, newVal) => {
                      const value = Math.max(1, Math.min(99, newVal));
                      handleQuantityChange(item.id, value);
                    }}
                    min={1}
                    max={99}
                    sx={{ flexShrink: 0 }}
                  />
                  <Checkbox
                    checked={!!selectedFilters[item.id]}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        ))}
        <Stack direction="row" spacing={1} alignItems="center">
          <FormControl sx={{ m: 2 }} component="fieldset" variant="standard">
            <FormLabel component="legend">Bestil efter timer:</FormLabel>
            <FormGroup sx={{ flexDirection: "row" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hourFilters.reset}
                    onChange={() => handleHourFilterChange("reset")}
                  />
                }
                label="Nulstil"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hourFilters[250]}
                    onChange={() => handleHourFilterChange(250)}
                  />
                }
                label="250"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hourFilters[500]}
                    onChange={() => handleHourFilterChange(500)}
                  />
                }
                label="500"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hourFilters[1000]}
                    onChange={() => handleHourFilterChange(1000)}
                  />
                }
                label="1000"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hourFilters.all}
                    onChange={() => handleHourFilterChange("all")}
                  />
                }
                label="Alle"
              />
            </FormGroup>
          </FormControl>
        </Stack>

        <Box
          sx={{
            width: "100%",
            height: "40px",
            backgroundColor: "#424242",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:hover": {
              backgroundColor: "#686868",
            },
            flexShrink: 0,
          }}
          onClick={handleAddToCart}
        >
          <IconButton
            aria-label="Add To Cart"
            size="large"
            disabled={!isAnySelected}
          >
            <AddShoppingCartRoundedIcon sx={{ color: "#ffffff" }} />
          </IconButton>
        </Box>
      </Stack>
    </>
  );
}

export default FilterInMachinesGroup;
